import * as Phaser from "phaser-ce"
import { CCUtils } from "../../../../common/CCUtils"

export enum SecondHandAssets {
    LUNGS = "SecondHandLUNGS",
    TABLE = "SecondHandTABLE",
    SKELETON = "SecondHandSKELETON",
    LONG_TERM_SMOKING = "SecondHandLONG_TERM_SMOKING",
    VAPOR_EXPERIMENT = "SecondHandVAPOR_EXPERIMENT",
    SHORT_TERM_SMOKING_EXPERIMENT = "SecondHandSHORT_TERM_SMOKING_EXPERIMENT",
    FULL_DESK = "SecondHandFULL_DESK",

    INTRO = "SecondHandINTRO",
    CHECKOUT_THE_REST = "SecondHandCHECKOUT_THE_REST",
    EXIT = "SecondHandEXIT",
}

export function loadAssets(game: Phaser.Game) {
    game.load.image(SecondHandAssets.LONG_TERM_SMOKING, CCUtils.asset("second-hand/main/mouse-experiment.png"))
    game.load.image(SecondHandAssets.LUNGS, CCUtils.asset("second-hand/main/lung-box.png"))
    game.load.image(SecondHandAssets.TABLE, CCUtils.asset("second-hand/main/desk.png"))
    game.load.image(SecondHandAssets.SKELETON, CCUtils.asset("second-hand/main/skeleton.png"))
    game.load.image(SecondHandAssets.VAPOR_EXPERIMENT, CCUtils.asset("second-hand/main/mom-box.png"))
    game.load.image(SecondHandAssets.SHORT_TERM_SMOKING_EXPERIMENT, CCUtils.asset("second-hand/main/people-car.png"))
    game.load.image(SecondHandAssets.FULL_DESK, CCUtils.asset("second-hand/main/full-desk.png"))

    game.load.audio(SecondHandAssets.INTRO, CCUtils.asset("second-hand/main/audio/intro.mp3"))
    game.load.audio(SecondHandAssets.CHECKOUT_THE_REST, CCUtils.asset("second-hand/main/audio/checkout-the-rest.mp3"))
    game.load.audio(SecondHandAssets.EXIT, CCUtils.asset("second-hand/main/audio/exit.mp3"))
}
